import { PaymentMethodDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

export const getSortedMethods = (methods: PaymentMethodDto[]) => {
  return Array.from(methods).sort((a, b) => {
    if (a.isDefault === b.isDefault) return 0;
    return a.isDefault ? -1 : 1;
  });
};
